import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPut } from '@/_shared/types/swagger';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_USER_CONTENT_FAVORITES_PATH_KEY } from '@/swagger/constants/contents-orchestrator-keys';
import { KEY_PUT_CONTENTS_FAVORITES, API_PUT_CONTENTS_FAVORITES } from '../constants';
import { MOCK_RESPONSE_PUT_CONTENTS_FAVORITES } from '../mocks';

export type RequestPutContentsFavorites = GenericPut<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_USER_CONTENT_FAVORITES_PATH_KEY
>['request']['path'] &
  GenericPut<
    typeof API_ORGANIZATIONS_ORGANIZATIONID_USER_CONTENT_FAVORITES_PATH_KEY
  >['request']['body'];

export type ResponsePutContentsFavorites = GenericPut<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_USER_CONTENT_FAVORITES_PATH_KEY
>['response']['body'];

export type CallParamsPutContentsFavorites = Omit<RequestPutContentsFavorites, 'organizationId'> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponsePutContentsFavorites = ResponsePutContentsFavorites;

type CallErrorPutContentsFavorites = {
  message: string;
  code: number;
};

type CallSelectorsPutContentsFavorites = unknown;

export const putContentsFavoritesCall = createGeneralCall<
  CallParamsPutContentsFavorites,
  CallResponsePutContentsFavorites,
  CallErrorPutContentsFavorites,
  CallSelectorsPutContentsFavorites
>({
  id: KEY_PUT_CONTENTS_FAVORITES,
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_PUT_CONTENTS_FAVORITES(org as unknown as string);
  },
  method: 'put',
  paramsSelector:
    ({ payload }) =>
    () => {
      return {
        ...payload,
      };
    },
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_PUT_CONTENTS_FAVORITES : undefined,
});
